import { MONTH_MESSAGES, MonthMessages } from "../month.messages";

export type ContactInfoTabMessages = MonthMessages & {
  contactInformationTitle: string;
  contactsSegmentTitle: string;
  contactTagTitle: string;
  citiesTagTitle: string;

  contactOriginLabel: string;
  birthdayPeriodLabel: string;

  genderLabel: string;
  minAgeLabel: string;
  maxAgeLabel: string;
  addTagLabel: string;
  tagExistsError: string;

  contactNameLabel: string;
  contactEmailLabel: string;
  contactPhoneLabel: string;
  contactCityLabel: string;
  contactStateLabel: string;
  optionsColumnLabel: string;

  errorRequiredContactOrigin: string;
  errorRequiredBirthdayDateRangeStart: string;
  errorRequiredBirthdayDateRangeEnd: string;
  errorRequiredGender: string;
  errorRequiredMinAge: string;
  errorRequiredMaxAge: string;

  noContactMessage: string;
  noActiveContactsFoundMessage: string;
  segmentSearchError: string;
  inactiveContactsExcludedAlert: string;
  inactiveContactsAlert: string;
  inactiveContactsDialogTitle: string;
  inactiveContactsDialogDescription: string;

  errorMinAgeNegative: string;
  errorMinAgeTooHigh: string;
  errorMaxAgeTooLow: string;
  errorMaxAgeTooHigh: string;
};

export const CONTACT_INFO_TAB_MESSAGES: ContactInfoTabMessages = {
  // Titles
  contactInformationTitle: "Segmentação",
  contactsSegmentTitle: "Contatos da campanha",
  contactTagTitle: "Tags de Contato",
  citiesTagTitle: "Cidades",

  // Labels
  contactOriginLabel: "Origem do Contato",
  birthdayPeriodLabel: "Período de Aniversário",
  genderLabel: "Sexo",
  minAgeLabel: "Idade Mínima",
  maxAgeLabel: "Idade Máxima",
  addTagLabel: "Adicione uma ou mais",
  tagExistsError: "Essa tag já existe nessa campanha",

  contactNameLabel: "Nome",
  contactEmailLabel: "Email",
  contactPhoneLabel: "Celular",
  contactCityLabel: "Cidade",
  contactStateLabel: "Estado",
  optionsColumnLabel: "Opções",

  // Error messages
  errorRequiredContactOrigin: "A origem do contato é obrigatória!",
  errorRequiredBirthdayDateRangeStart: "A data de início do período de aniversário é obrigatória!",
  errorRequiredBirthdayDateRangeEnd: "A data de fim do período de aniversário é obrigatória!",
  errorRequiredGender: "O gênero é obrigatório!",
  errorRequiredMinAge: "A idade mínima é obrigatória!",
  errorRequiredMaxAge: "A idade máxima é obrigatória!",

  noContactMessage: "Clique em pesquisar para verificar os contatos alcançados.",
  noActiveContactsFoundMessage: "Nenhum contato ativo encontrado para esta segmentação.",
  segmentSearchError: "Não foi possível carregar os contatos da segmentação. Tente novamente.",
  inactiveContactsExcludedAlert:
    "Os filtros selecionados correspondem apenas a contatos inativos. Contatos inativos não são incluídos em campanhas. Reative os contatos ou ajuste a segmentação.",
  inactiveContactsAlert:
    "A segmentação inclui contatos inativos (tags, cidade, sexo, idade ou outros filtros). Contatos inativos não recebem campanha. Ajuste os filtros ou reative os contatos antes de salvar.",
  inactiveContactsDialogTitle: "Contatos inativos na segmentação",
  inactiveContactsDialogDescription:
    "Somente contatos ativos podem ser incluídos em campanhas. Remova contatos inativos da segmentação ou reative-os para continuar.",

  // Error messages for age validation
  errorMinAgeNegative: "A idade mínima não pode ser negativa!",
  errorMinAgeTooHigh: "A idade mínima não pode ser maior que 120!",
  errorMaxAgeTooLow: "A idade máxima não pode ser menor que a idade mínima!",
  errorMaxAgeTooHigh: "A idade máxima não pode ser maior que 120!",

  ...MONTH_MESSAGES,
};
